import { render, staticRenderFns } from "./couponRule.vue?vue&type=template&id=5839b234&"
import script from "./couponRule.vue?vue&type=script&lang=js&"
export * from "./couponRule.vue?vue&type=script&lang=js&"
import style0 from "./couponRule.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports